package com.anjuros.website.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.anjuros.website.components.changeMode
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.components.setMeta
import com.anjuros.website.redesign.components.RdScrollReveal
import com.anjuros.website.redesign.components.SiteFooter
import com.anjuros.website.redesign.components.SiteHeader
import com.anjuros.website.redesign.components.rdNavItems
import com.anjuros.website.redesign.components.setJsonLd
import com.anjuros.website.redesign.sections.about.AboutBrandsSection
import com.anjuros.website.redesign.sections.about.AboutClosingSection
import com.anjuros.website.redesign.sections.about.AboutHeroSection
import com.anjuros.website.redesign.sections.about.AboutPrinciplesSection
import com.anjuros.website.redesign.sections.about.AboutServicesSection
import com.anjuros.website.redesign.sections.about.AboutStorySection
import com.anjuros.website.redesign.sections.about.AboutWorkSection
import com.anjuros.website.redesign.sections.about.SHOW_CLIENT_WORK
import com.anjuros.website.redesign.sections.about.aboutStructuredData
import com.anjuros.website.redesign.styles.RdPageStyle
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.SITE_URL
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Main

@Page
@Composable
fun About() {
    val title = LocalText(RdText.ABOUT_META_TITLE)
    val description = LocalText(RdText.ABOUT_META_DESCRIPTION)
    val structuredData = aboutStructuredData()

    LaunchedEffect(Unit) {
        setMeta(title, description, url = "$SITE_URL${RdRoute.ABOUT}")
        setJsonLd("ld-about", structuredData)
        changeMode(UiMode.NORMAL)
    }

    Div(RdPageStyle.toModifier().toAttrs()) {
        SiteHeader(rdNavItems(currentPath = RdRoute.ABOUT))
        Main {
            AboutHeroSection()
            AboutBrandsSection()
            AboutStorySection()
            if (SHOW_CLIENT_WORK) AboutWorkSection()
            AboutPrinciplesSection()
            AboutServicesSection()
            AboutClosingSection()
        }
        SiteFooter()
        RdScrollReveal()
    }
}
